import { z } from "zod";

/** Tools that live in the shared pool volume and can be updated without rebuilding the image. */
export const ToolId = z.enum(["claude", "codex", "gemini", "antigravity", "kimi", "code-server", "chromium", "codvero", "gh", "node", "ripgrep", "fd", "jq", "pnpm", "uv"]);
export type ToolId = z.infer<typeof ToolId>;

export const ToolJobPhase = z.enum(["installing", "done", "failed"]);
export const ToolJob = z.object({
  tool: ToolId,
  version: z.string(),
  phase: ToolJobPhase,
  /** Tail of the installer output. */
  log: z.string(),
  startedAt: z.string(),
  finishedAt: z.string().nullable(),
});
export type ToolJob = z.infer<typeof ToolJob>;

export const ToolStatus = z.object({
  id: ToolId,
  label: z.string(),
  /** What the pool serves right now (null = the version baked into the image). */
  installed: z.string().nullable(),
  /** The version the pool can roll back to. */
  previous: z.string().nullable(),
  /** The version baked into the base image (the fallback when the pool has nothing). */
  image: z.string().nullable(),
  /** Newest published version, as of `checkedAt`. */
  latest: z.string().nullable(),
  /** Effective version in use = installed ?? image. */
  effective: z.string().nullable(),
  updateAvailable: z.boolean(),
  /** Not part of the image: only exists when installed into the pool. */
  optional: z.boolean().default(false),
  job: ToolJob.nullable(),
});
export type ToolStatus = z.infer<typeof ToolStatus>;

export const ToolsOverview = z.object({
  tools: z.array(ToolStatus),
  checkedAt: z.string().nullable(),
  /** The pool volume is mounted only into containers created after it was introduced. */
  poolVolume: z.string(),
});
export type ToolsOverview = z.infer<typeof ToolsOverview>;

export const UpdateToolInput = z.object({ version: z.string().trim().min(1).max(60).optional() });
